import { setSearchLineIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice"
import { store } from "../../../../stateManagement/store"

export function controlSearchLineButton() {
    const searchLineIsShown = store.getState().contentHeader.searchLineIsShown
    store.dispatch(setSearchLineIsShown(!searchLineIsShown))
}

export function controlPathNormativitiesInfoFilterButton(navigate: any){
    navigate('/app/diagnostics/pathNormativities/filters')
}